document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded event fired - menu closing script started');
  
  // 1. Target the menu drawer container
  const menuDrawerContainer = document.getElementById('Details-menu-drawer-container');
  
  if (!menuDrawerContainer) {
    console.error('Menu drawer container not found! Check ID: Details-menu-drawer-container');
    return;
  }
  
  console.log('Menu drawer container found:', menuDrawerContainer);
  
  // 2. Get all menu items
  const menuItems = document.querySelectorAll('#menu-drawer .menu-drawer__menu-item');
  
  if (!menuItems.length) {
    console.error('No menu items found! Check selector: #menu-drawer .menu-drawer__menu-item');
    return;
  }
  
  console.log(`Found ${menuItems.length} menu items`);
  
  // 3. Close menu function with detailed logging
  const closeMobileMenu = () => {
    console.log('Closing mobile menu...');
    
    // Remove open attribute
    if (menuDrawerContainer.hasAttribute('open')) {
      menuDrawerContainer.removeAttribute('open');
      console.log('Removed "open" attribute from menu container');
    } else {
      console.log('Menu container did not have "open" attribute');
    }
    
    // Update hamburger button state
    const hamburgerButton = document.querySelector('.header__icon--summary');
    if (hamburgerButton) {
      hamburgerButton.setAttribute('aria-expanded', 'false');
      console.log('Set hamburger button aria-expanded to false');
    } else {
      console.warn('Hamburger button not found! Check selector: .header__icon--summary');
    }
    
    // Remove body scroll lock
    if (document.body.classList.contains('overflow-hidden')) {
      document.body.classList.remove('overflow-hidden');
      console.log('Removed overflow-hidden class from body');
    } else {
      console.log('Body did not have overflow-hidden class');
    }
    
    console.log('Mobile menu should be closed now');
  };
  
  // 4. Add click event to each menu item
  menuItems.forEach((item, index) => {
    item.addEventListener('click', (event) => {
      console.log(`Menu item ${index + 1} clicked:`, item.textContent.trim());
      console.log('Before closing - Menu open state:', menuDrawerContainer.hasAttribute('open') ? 'OPEN' : 'CLOSED');
      
      closeMobileMenu();
      
      // Log state after closing
      setTimeout(() => {
        console.log('After closing - Menu open state:', menuDrawerContainer.hasAttribute('open') ? 'OPEN' : 'CLOSED');
        console.log('---');
      }, 100);
    });
  });
  
  console.log('Menu closing handler setup complete');
});